import React, { useState } from "react"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Button,
  Input,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@nextui-org/react"
import { usePost } from "../../api/reactQueryCustomHooks"

function CreateAdminMaster() {
  const navigate = useNavigate()
  const [errors, setErrors] = useState({})
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)
  const { onOpenChange, onClose } = useDisclosure()

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirm_password: "",
  })

  const resetValues = () => {
    setFormData({
      username: "",
      password: "",
      confirm_password: "",
    })
  }
  const onSuccessTasks = (data) => {
    onCloseModel()
  }

  const { isPending, mutate: insertAdminMaster } = usePost({
    url: apiRoute.adminMaster.add,
    queryKey: "AdminMaster",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate username
    if (formData.username.trim() === "") {
      newErrors.username = "Username is required"
    }

    // Validate password
    if (formData.password.trim() === "") {
      newErrors.password = "Password is required"
    }

    // Validate confirm_password
    if (formData.confirm_password.trim() === "") {
      newErrors.confirm_password = "confirm_password is required"
    }

    // Validate confirm_password
    if (formData.confirm_password !== formData.password) {
      newErrors.confirm_password =
        "Confirm Password needs to be same same Password"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const onCloseModel = () => {
    navigate(linksUrl.adminMaster.read)
    onClose()
  }

  const onSubmit = () => {
    // Validate the form before submission
    if (validateForm()) {
      // Perform form submission logic here
      insertAdminMaster({
        data: {
          username: formData.username,
          password: formData.password,
          confirm_password: formData.confirm_password,
        },
      })
    }
  }

  return (
    <div>
      <Modal
        isOpen={true}
        onOpenChange={onOpenChange}
        placement="top-center"
        hideCloseButton
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                Create Admin Master
              </ModalHeader>
              <ModalBody>
                <Input
                  type="text"
                  label="Username"
                  placeholder=" "
                  labelPlacement="inside"
                  isInvalid={errors?.username}
                  errorMessage={errors?.username}
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
                <Input
                  label="Password"
                  labelPlacement="inside"
                  placeholder="Enter your password"
                  name="password"
                  isInvalid={errors?.password}
                  errorMessage={errors?.password}
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
                <Input
                  label="Confirm Password"
                  labelPlacement="inside"
                  placeholder="Confirm password"
                  name="confirm_password"
                  isInvalid={errors?.confirm_password}
                  errorMessage={errors?.confirm_password}
                  value={formData.confirm_password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
              </ModalBody>
              <ModalFooter>
                <Button
                  color="danger"
                  variant="flat"
                  onPress={onCloseModel}
                  isDisabled={isPending}
                >
                  Close
                </Button>
                <Button
                  color="primary"
                  onPress={onSubmit}
                  isLoading={isPending}
                >
                  Create Admin Master
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  )
}

export default CreateAdminMaster
